import { BaseService } from './base.service';

export class FloorService extends BaseService {
    baseUrl = '/floor';
}
